module.exports = "/fonts/fa-solid-900.eot?ef3df98419d143d9617fe163bf4edc0b";